import { ColumnSortingOrder } from "@/modules/types/datatableTypes"

export function isValidSortOrder(sortOrder: string): sortOrder is ColumnSortingOrder {
  return Object.values(ColumnSortingOrder).includes(sortOrder as ColumnSortingOrder)
}
